module.exports = __webpack_public_path__ + "static/img/channel_banner1.a5c3b2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/channel_banner1.jpg
// module id = Bm02
// module chunks = 0